.content {
  max-width: min(22rem, calc(100vw - 20px));
  padding: 1rem;

  > div {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    max-width: 100%;

    > p {
      margin: 0;
    }
  }
}
